import { Suspense, lazy } from "react";
import Loader from "./common/Loader"; // We need to verify where Loader is or create a simple fallback
import Home from "./components/layout/Home"; // Keep Home eager for LCP
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import {
  Route,
  Routes,
  useLocation,
  Link,
  BrowserRouter,
} from "react-router-dom";
import { useEffect } from "react";
import ParticlesBackground from "./components/animations/BackgroundFX";
import ScrollToTopButton from "./common/ScrollToTopButton";

// Lazy load other pages
const AboutPage = lazy(() => import("./components/pages/AboutPage"));
const ProcessPage = lazy(() => import("./components/pages/ProcessPage"));
const ProductsPage = lazy(() => import("./components/pages/ProductsPage"));
const ProjectsPage = lazy(() => import("./components/pages/ProjectsPage"));
const Contact = lazy(() => import("./components/pages/Contact"));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

function Shell() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash, pathname]);

  return (
    <div className="min-h-screen relative">
      <ParticlesBackground />
      <Header />
      <main className="pt-16">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/process" element={<ProcessPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="*"
              element={
                <div className="max-w-4xl mx-auto px-4 py-24">
                  <h1 className="text-3xl font-bold">Page not found</h1>
                  <p className="text-white/70 mt-3">
                    Try going{" "}
                    <Link to="/" className="underline">
                      home
                    </Link>
                    .
                  </p>
                </div>
              }
            />
          </Routes>
        </Suspense>
        <Footer />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Shell />
      <ScrollToTopButton />
    </BrowserRouter>
  );
}
